export const buildTickets = (priceGroup, existingTickets) => {
  let tickets = []
  /*
    here we are building a list of purchasable items for our cart
    our pricing structure from the api is a little complicated
    so first we need to break it down by price group
  */
  if (priceGroup) {
    Object.values(priceGroup).forEach(group => {
      // then we iterate over the priceTypes object to get purchasable ticket types
      Object.values(group.types).forEach(priceType => {
        let ticket
        if (existingTickets) {
          // making sure that current cart ticket data is included
          ticket = existingTickets.find(
            existingTicket =>
              existingTicket.priceTypeId === priceType.id ||
              existingTicket.ageGroup === priceType.ageGroup
          )
        }
        // if we don't have any existing tickets for the event, we set the defaults
        if (!ticket) {
          ticket = {
            ...priceType,
            priceTypeId: priceType.id,
            subLabel: group.label,
            ageGroup: group.ageGroup,
            quantity: 0
          }
        }
        ticket = {
          ...ticket,
          upperLimit: priceType.upperLimit,
          lowerLimit: priceType.lowerLimit
        }
        tickets = [...tickets, ticket]
      })
    })
    return tickets
  }
}

/*
 * Builds price type options with the appropriate zone id that has been selected (or 0 if none has been passed in)
 * */
export const buildTicketsFromZone = (
  priceGroup,
  existingTickets,
  chosenZone
) => {
  let tickets = []

  /*
   * If no zone is passed in, use the original logic.
   * TODO: This needs to be revisted when zone are fully implemented.
   *
   * See if we can just default zoneId to 0 if no chosen zone is present and use that logic for the rest of the function.
   * That will enable us to eliminate this logic.
   * */
  if (!chosenZone) {
    return buildTickets(priceGroup, existingTickets)
  }
  /*
    here we are building a list of purchasable items for our cart
    our pricing structure from the api is a little complicated
    so first we need to break it down by price group
  */

  Object.values(priceGroup).forEach(group => {
    // then we iterate over the priceTypes object to get purchasable ticket types
    Object.values(group.types).forEach(priceType => {
      let ticket
      if (existingTickets) {
        // making sure that current cart ticket data is included
        ticket = existingTickets.find(
          existingTicket =>
            (existingTicket.priceTypeId === priceType.id ||
              existingTicket.ageGroup === priceType.ageGroup) &&
            existingTicket.zoneId === chosenZone.zoneId
        )
      }
      // if we don't have any existing tickets for the event, we set the defaults
      if (!ticket) {
        ticket = {
          ...priceType,
          priceTypeId: priceType.id,
          subLabel: group.label,
          ageGroup: group.ageGroup,
          quantity: 0,
          zoneId: chosenZone.zoneId
        }
      }
      ticket = {
        ...ticket,
        upperLimit: priceType.upperLimit,
        lowerLimit: priceType.lowerLimit
      }
      tickets = [...tickets, ticket]
    })
  })
  return tickets
}
